// extracted by mini-css-extract-plugin
export default {"root":"Page_root__FlYGy","document":"Page_document__sSlXz","title":"Page_title__8Ohjw","active":"Page_active__BAVMJ"};